export default __webpack_public_path__ + "static/media/3.b1728bc3.mp3";